import type { MouseEvent } from 'react';

import { cn } from '@poseidon/components/cn';
import { Button } from '@poseidon/components/Input2';
import { General } from '@poseidon/components/StrokeIcons';

type Props = {
  testId?: string;
  tooltip: string;
  onClick: (e: MouseEvent) => void;
  /** Extra classes — positioning / hover-reveal for callers that need it (e.g. the step-group tile). */
  className?: string;
};

/**
 * The ONE dashed-circle "+" add-tile shared by every minimal-mode touch-graph
 * affordance — the step-group add tile, the trailing add-node, each fork-arm add-node,
 * and the not-accepted stub. Every add in the compact graph reads as the same control,
 * so they all render this identical tile (sized to match the compact step chips, `size-8`)
 * rather than each hand-rolling its own shape / border weight / plus size.
 */
export function MinimalAddTile({ testId, tooltip, onClick, className }: Props) {
  return (
    <Button
      data-testid={testId}
      text
      size="2xs"
      icon={<General.Plus className="size-5 shrink-0" />}
      tooltip={tooltip}
      onClick={onClick}
      className={cn(
        'flex size-8 shrink-0 items-center justify-center rounded-full border border-dashed p-0',
        'border-lynch-300 text-lynch-400 hover:border-blue-400 hover:bg-blue-50 hover:text-blue-500',
        'dark:border-slate-600 dark:text-lynch-500 dark:hover:border-blue-400 dark:hover:bg-blue-950 dark:hover:text-blue-300',
        className,
      )}
    />
  );
}
